/*
 * � 2020 Microsoft. All rights reserved.
 */

define('MenuUI/DropShadow',['pixi', 'absolute', 'lodash'],

    function (PIXI, Absolute, _) {

        var DropShadow = function (config) {

            var defaultConfig = {
                beginningShade: 0.07,
                finalShade: 0.001,
                easeOut: function (x) {
                    return Math.pow(0.8, x);
                },
                baseWidth: Absolute.Coords.x(100),
                baseHeight: Absolute.Coords.x(100),
                xOffset: Absolute.Coords.x(15),
                yOffset: Absolute.Coords.x(15)
            };
            this.initDropShadow(_.extend(defaultConfig, config));
        };

        DropShadow.prototype = Object.create(PIXI.DisplayObjectContainer.prototype);

        DropShadow.prototype.initDropShadow = function (config) {

            PIXI.DisplayObjectContainer.call(this);

            this.config = config;

            var shade = this.config.beginningShade,
                index = 0;

            // todo: generate texture from this to reduce elements on screen?
            while(shade > this.config.finalShade) {
                var dropShadow = new PIXI.Graphics();
                shade = this.config.beginningShade * this.config.easeOut(index);
                dropShadow.beginFill(0x000001, shade);
                dropShadow.drawRect(this.config.xOffset * this.config.easeOut(index), this.config.yOffset * this.config.easeOut(index), this.config.baseWidth, this.config.baseHeight);
                dropShadow.endFill();
                this.addChildAt(dropShadow, 0);
                index++;
            }


        };

        return DropShadow;

    });
